// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__hieOS","header":"Layout_header__0odJc","content":"Layout_content__Bh91Z","footer":"Layout_footer__gsTRI"};